import Cookies from 'js-cookie';

import axiosInstance from "@/common/axiosInstance";

const getAccessToken = async () => {
    const refreshToken = Cookies.get('refresh_token');
    const URL = `Auth/GetAccessToken/${refreshToken}`;

    try {
        return await axiosInstance.get<any[]>(URL);
    } catch (err: any) {
        const obj = {
            status: err?.response?.status,
            message: err?.response?.data?.message
        }
        return obj;
    }
};

export {
    getAccessToken
}
